import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SEO } from '../components/shared/SEO';
import { CategoryPLP } from './CategoryPLP';
import { Header } from '../components/layout/Header';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { Footer } from '../components/layout/Footer';
import { MobileFooterNav } from '../components/layout/MobileFooterNav';
import { PharmacistChat } from '../components/services/PharmacistChat';
import { MobileDeliverToPill } from '../components/layout/MobileDeliverToPill';
import { MobileHomeHeader } from '../components/MobileHomeHeader';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { generateBreadcrumbJsonLd, generateItemListJsonLd, generateOrganizationJsonLd } from '../utils/seo/jsonLd';
export function CategoryPage() {
  const {
    categoryName
  } = useParams<{
    categoryName: string;
  }>();
  const [searchParams] = useSearchParams();
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<{
    name: string;
  } | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const displayName = categoryName?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') || 'Category';
  const description = `Shop ${displayName} essentials at Innova Pharmacy — top products, great prices, and fast delivery across Saudi Arabia. Secure checkout and 24/7 support.`;
  const categorySlug = categoryName?.toLowerCase().replace(/\s+/g, '-') || 'category';
  const currentPage = parseInt(searchParams.get('page') || '1', 10);
  const hasFilters = searchParams.has('brand') || searchParams.has('price') || searchParams.has('sort');
  const canonicalUrl = currentPage > 1 ? `/en/${categorySlug}/?page=${currentPage}` : `/en/${categorySlug}/`;
  const hreflangArUrl = currentPage > 1 ? `/${categorySlug}/?page=${currentPage}` : `/${categorySlug}/`;
  const hreflangEnUrl = currentPage > 1 ? `/en/${categorySlug}/?page=${currentPage}` : `/en/${categorySlug}/`;
  const prevUrl = currentPage > 2 ? `/en/${categorySlug}/?page=${currentPage - 1}` : currentPage === 2 ? `/en/${categorySlug}/` : undefined;
  const nextUrl = currentPage < 5 ? `/en/${categorySlug}/?page=${currentPage + 1}` : undefined;
  const robotsMeta = hasFilters ? 'noindex,follow' : 'index,follow';
  const categoryKeywords = [displayName, 'Saudi Arabia', 'online pharmacy', 'health products', 'authentic products', 'fast delivery'].join(', ');
  // JSON-LD schemas
  const breadcrumbJsonLd = generateBreadcrumbJsonLd([{
    label: 'Home',
    href: '/'
  }, {
    label: displayName
  }]);
  const organizationJsonLd = generateOrganizationJsonLd();
  // Mock products for ItemList schema
  const mockProducts = [{
    id: 1,
    name: 'Sample Product',
    price: 100,
    image: 'https://example.com/product.jpg'
  }];
  const itemListJsonLd = generateItemListJsonLd(mockProducts, displayName);
  const jsonLdSchemas = [breadcrumbJsonLd, organizationJsonLd, itemListJsonLd];
  return <HelmetProvider data-id="element-6526" data-mp="uyqtoohi2t8p">
      <SEO title={displayName} description={description} canonical={canonicalUrl} ogImage={`https://cdn.innovaksa.net/og/${categorySlug}.jpg`} robots={robotsMeta} hreflangAr={hreflangArUrl} hreflangEn={hreflangEnUrl} hreflangDefault={hreflangArUrl} prevUrl={prevUrl} nextUrl={nextUrl} keywords={categoryKeywords} jsonLd={jsonLdSchemas} data-id="element-6527" data-mp="v2eodqyollp0" />
      <div className="flex flex-col min-h-screen bg-gray-50 overflow-x-hidden" data-id="element-6528" data-mp="1rq2u19hk3lro">
        <div className="hidden md:block" data-id="element-6529" data-mp="1nozbgf84jbmr">
          <Header locationModalOpen={locationModalOpen} setLocationModalOpen={setLocationModalOpen} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} disableShrink={false} showAnnouncement={true} data-id="element-6530" data-mp="1nqageidb2pfg" />
        </div>
        <main className="flex-grow overflow-x-hidden pt-0 md:pt-[var(--header-height-desktop)]" data-id="element-6531" data-mp="3qyb3poogedlq">
          <h1 className="sr-only" data-id="element-6532" data-mp="3vvt3aogkzgh2">
            {displayName} - Shop Quality Healthcare Products
          </h1>
          <PageHeroBreadcrumb breadcrumbs={[{
          label: 'Home',
          href: '/'
        }, {
          label: displayName
        }]} title={displayName} description={description} data-id="element-6533" data-mp="2yayknohi4nx6" />
          <CategoryPLP categoryName={displayName} categoryDescription={description} data-id="element-6534" data-mp="ngsyzq3z9mpj" />
        </main>
        <div className="hidden md:block" data-id="element-6535" data-mp="rhmlqg5oovgu">
          <Footer data-id="element-6536" data-mp="rkh6y9wiukbb" />
        </div>
        <MobileFooterNav data-id="element-6537" data-mp="2c06uvwc84so8" />
        <PharmacistChat data-id="element-6538" data-mp="2bzdl0mhyxn1v" />
        <div className="h-16 md:hidden" data-id="element-6539" data-mp="2bzx1dyrz03ds"></div>
      </div>
    </HelmetProvider>;
}